import { apiAdd, apiUpdate } from "../../API/Service/apiClient";

export const handleAE_supplierPartyForm = async({
  setLoading,data,showAlert,resetForm,
  navigate})=>{      
  let id= data?.id || 0; 

  setLoading(true)
  
  try {
    let resData={};
    if(id > 0){     
      resData =await apiUpdate("supplier-party-data",data,{contentType:"multipart/form-data"});         
    }else{
      resData =await apiAdd("supplier-party-data",data,{contentType:"multipart/form-data"});        
    }
    if(resData?.data === -1){            
      showAlert({
        title: "Error?",
        message: "This supplier/party is already registered with us.",
        type: "error",
        confirmLabel: "Ok",
        cancelLabel: "Cancel",    
        showCancel: false,      
      });
    }
    else if(resData?.data > 0){
      showAlert({
        title: "Success",
        message: "Record saved successfully",
        type: "success",
        confirmLabel: "Ok",
        cancelLabel: "Cancel", 
        showCancel: false,   
        onConfirm: () => {                       
          resetForm();         
          navigate('/admin/sup-list')           
        },      
      });

    }else{
      showAlert({
        title: "Error?",
        message: "Oops! Something went wrong. Please try again later.",
        type: "error",
        confirmLabel: "Ok",
        cancelLabel: "Cancel", 
        showCancel: false,         
      });
    }
    
  } catch (error) {
    // console.log(error);
     
  }finally{
    setLoading(false)
  }
}

